import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../supabase';

const ProtectedRoute = (props) => {
  const [status, setStatus] = useState('loading');
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    const checkAdmin = async () => {
      const { data: sessionData } = await supabase.auth.getSession();

      if (!sessionData.session) {
        setStatus('unauthenticated');
        return;
      }

      setUserEmail(sessionData.session.user.email || '');

      const { data, error } = await supabase
        .from('admin_users')
        .select('id')
        .eq('auth_id', sessionData.session.user.id)
        .maybeSingle();

      setStatus(!error && data ? 'allowed' : 'forbidden');
    };

    checkAdmin();
  }, []);

  const signOut = async () => {
    await supabase.auth.signOut();
    setStatus('unauthenticated');
  };

  if (status === 'loading') {
    return <div className="route_loader">Loading...</div>;
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/" replace />;
  }

  if (status === 'forbidden') {
    return (
      <main className="access_denied_page">
        <section className="access_denied_card">
          <p>Access denied</p>
          <h1>You don't have access</h1>
          <span>
            {userEmail || 'This account'} is signed in, but it is not registered as an admin.
          </span>
          <button onClick={signOut} type="button">
            Sign out
          </button>
        </section>
      </main>
    );
  }

  return props.children;
};

export default ProtectedRoute;
